<template>
    <div class="two-column-layout">
		<div class="container">
			<div class="columns">
				<div class="column is-left">
					<slot name="left"></slot>
				</div>
				<div class="column is-right is-one-quarter">
					<slot name="right"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "TwoColumnLayout"
}
</script>